<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!setting">
    <tt-card>
        <tt-input ttLabel="batchdelivery_keyno" [ttModel]="setting.batchdelivery_keyno" ttReadonly></tt-input>
        <tt-input ttRememberId="w_batchdelreceivelines.searchtext" ttLabel="searchtext" ttFocus="true" [(ttModel)]="setting.searchtext" ttShowClearButton></tt-input>
    </tt-card>

    <tt-list [ttData]="itemsListReceiveLines" [ttFilter]="setting.searchtext"></tt-list>

    <tt-card>
        <tt-button-goto [ttText]="'batchdelreceivelines_deviations'" [ttBadge]="setting.nbr_of_deviations" [ttGoto]="'deviations'" [ttGotoParms]="{ argtype: 'batchdelivery_keyno', argvalue: setting.batchdelivery_keyno }"></tt-button-goto>
    </tt-card>
</tt-page>
